import { ReactElement } from 'react';
import { styled } from 'styled-components';

const TitleBlock = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Heading = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

const Count = styled.span`
  font-size: 14px;
  color: #666;
`;

interface Props {
  total: number;
  displayStart: number;
  displayEnd: number;
}

const Title = ({ total, displayStart, displayEnd }: Props): ReactElement => (
  <TitleBlock>
    <Heading>録音</Heading>
    <Count>
      {total}件中 {displayStart}-{displayEnd}件を表示
    </Count>
  </TitleBlock>
);

export default Title;
